// eslint-disable-next-line no-restricted-imports -- the ripple and loading track sit on the dark bulk actions bar
import { grey } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
import { withEllipsis } from "@styles/common-styles";

/**
 * Configuration object for bulk action button styling and behavior
 */

/**
 * Returns button configuration for each bulk action mode.
 * Provides consistent styling across all bulk action buttons.
 *
 * @param mode - The current bulk actions display mode
 * @param tooltipText - The tooltip text to show (only in non-collapsed modes)
 * @returns Configuration object with styling and behavior settings
 */
export function getBulkActionButtonConfig(mode, tooltipText) {
  const configs = {
    collapsed: {
      tooltipText: undefined,
      loadingTrackColor: grey[400],
      rippleColor: grey[500],
      shouldShowText: true,
      sx: {
        width: "100%",
        justifyContent: "flex-start",
        color: "text.primary",
        "&:hover": {
          color: "primary.main"
        },
        "& span": {
          color: "inherit"
        }
      }
    },
    compact: {
      tooltipText,
      loadingTrackColor: grey[200],
      rippleColor: grey[500],
      shouldShowText: false,
      sx: {
        color: PALETTE_VARS.common.white,
        minWidth: "auto",
        "& span": {
          margin: 0
        }
      }
    },
    full: {
      tooltipText,
      loadingTrackColor: grey[200],
      rippleColor: grey[500],
      shouldShowText: true,
      sx: {
        color: PALETTE_VARS.common.white,
        maxWidth: 200,
        // The flat-ui Button wraps its content in a Stack, so the label is no
        // longer a direct child of the button. `Text` sets its own colour and
        // never inherits, so it needs to be reached by a descendant selector.
        "& span": {
          color: PALETTE_VARS.common.white,
          ...withEllipsis
        }
      }
    }
  };
  return configs[mode];
}